export default "__VITE_ASSET__BNkuXtiG__"